import { render } from "./fire-register-index.vue?vue&type=template&id=99afe354&scoped=true"
import script from "./fire-register-index.vue?vue&type=script&lang=js"
export * from "./fire-register-index.vue?vue&type=script&lang=js"

import "./fire-register-index.vue?vue&type=style&index=0&id=99afe354&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99afe354"]])

export default __exports__